import * as yup from "yup";

export const filtrosUsuariosSchema =  yup.object().shape({
  nome: yup.string(),
  email: yup.string(),
  perfil: yup.string()
});
  